import { widgetManager } from '../../src/widgetManager/index.js'
import templates from '/app/templates'
import BaseChannel from './base'

export default class WhatsAppChannel extends BaseChannel {
  constructor(settings, { widgetContainer, whatsappService, texts, billingService, agentImage, widgetIndex }) {
    super(settings, { widgetContainer })
    this.texts = texts
      .filter((x) => x.type === 'whatsApp')
      .reduce(function (map, obj) {
        map[obj.key] = obj.value
        return map
      }, {})
    this.fields = settings.fields || []

    this.sipState = {}
    this.billingService = billingService
    this.agentImage = agentImage
    this.whatsappService = whatsappService

    this.channelType = 'whatsapp'

    this.formattedTime = this.getTime()
    this.userLocale = widgetContainer.settings.widgets[widgetIndex].locale

    this.widgetContainer = widgetContainer
    this.widgetIndex = widgetIndex
  }

  getTime() {
    var currentTime = new Date()

    // Pobranie godziny i minut
    var hours = currentTime.getHours()
    var minutes = currentTime.getMinutes()

    // Formatowanie godziny i minut do postaci "hh:mm"
    if (hours < 10) {
      hours = '0' + hours // Dodanie zera z przodu, jeśli godzina jest jednocyfrowa
    }
    if (minutes < 10) {
      minutes = '0' + minutes // Dodanie zera z przodu, jeśli minuta jest jednocyfrowa
    }

    // Złożenie godziny i minut w jeden string w formacie "hh:mm"
    this.formattedTime = hours + ':' + minutes
    return this.formattedTime
  }

  setup() {
    this.styleNamespace = 'cce-widget-whatsapp'
  }

  open(instantRedirect) {
    if (instantRedirect) {
      this.billingService.addInteraction({
        interactionType: 'WhatsApp',
        additionalInfo: {
          visitorId: this.widgetContainer.token,
        },
      })
      const phone = this.params.phone.replace(/^\+/, '')

      let msg = ''

      if (this.widgetContainer.settings.widgets[this.widgetIndex].customAttributes) {
        const tags = this.widgetContainer.settings.widgets[this.widgetIndex].customAttributes.map((attr) => attr.tag).filter((tag) => tag)
        const tagsString = tags.length > 0 ? tags.map((tag) => `[${tag}]`).join(' ') : ''

        if (tagsString.length > 0) {
          msg = `${tagsString} `
        }
      }

      window.open(`https://api.whatsapp.com/send?phone=${phone}${msg !== '' ? `&text=${msg}` : ''}`, '_blank')
      this.widgetContainer.triggerPublicEvent('widget_business_success', { state: widgetManager.getState(), confirmed: true })
      return
    }

    this.$element = document.createElement('div')
    this.$element.classList.add(this.styleNamespace)
    this.render()

    this.formattedTime = this.getTime()
  }

  render() {
    this.$element.innerHTML = templates.whatsapp(this.getTemplateVariables())

    this.observeEvents()
    this.initWhatsapp()
  }

  getTemplateWhatsAppTexts(language) {
    switch (language) {
      case 'en':
        return 'Hi 👋' + '</br>' + 'After sending the first message, you will be taken to WhatsApp'
      case 'ar':
        return ' بعد إرسال الرسالة الأولى، سيتم نقلك إلى واتساب' + '</br>' + 'مرحبًا 👋'
      case 'ar-ae':
        return ' بعد إرسال الرسالة الأولى، سيتم نقلك إلى واتساب' + '</br>' + 'مرحبًا 👋'
      case 'de':
        return 'Hallo 👋' + '</br>' + ' Nachdem Sie die erste Nachricht gesendet haben, werden Sie zu WhatsApp weitergeleitet'
      case 'es':
        return 'Hola 👋' + '</br>' + ' Después de enviar el primer mensaje, serás llevado a WhatsApp'
      case 'fr':
        return 'Salut 👋' + '</br>' + ' Après avoir envoyé le premier message, vous serez dirigé vers WhatsApp'
      case 'pl':
        return 'Cześć 👋' + '</br>' + ' Po wysłaniu pierwszej wiadomości zostaniesz przeniesiony na WhatsApp'
      case 'pt':
        return 'Olá 👋' + '</br>' + ' Após enviar a primeira mensagem, você será levado para o WhatsApp'
      default:
        return 'Hi 👋' + '</br>' + ' After sending the first message, you will be taken to WhatsApp'
    }
  }

  getTemplateVariables() {
    if (!this.texts.welcomeMessage) {
      this.texts.welcomeMessage = this.getTemplateWhatsAppTexts(this.userLocale)
    }

    return {
      styleNamespace: this.styleNamespace,
      agreementQuestions: [],
      additionalFields: this.fields || [],
      phone: this.params.phone,
      texts: this.texts,
      isMobile: this.isMobile,
      agentImage: this.agentImage,
      time: this.formattedTime,
    }
  }

  observeEvents() {
    this.$element.querySelector('form').addEventListener('submit', (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.sendMessage()
    })
  }

  sendMessage() {
    const msgBox = this.$element.querySelector('.cce-widget-whatsapp__new-message textarea')
    let msg = msgBox.value

    if (this.widgetContainer.settings.widgets[this.widgetIndex].customAttributes) {
      const tags = this.widgetContainer.settings.widgets[this.widgetIndex].customAttributes.map((attr) => attr.tag).filter((tag) => tag)
      const tagsString = tags.length > 0 ? tags.map((tag) => `[${tag}]`).join(' ') : ''

      if (tagsString.length > 0) {
        msg = `${tagsString} ${msgBox.value}`
      }
    }
    const phone = this.params.phone.replace(/^\+/, '')

    window.open(`https://api.whatsapp.com/send?phone=${phone}&text=${msg}`, '_blank')
    msgBox.value = ''

    document.querySelector('button[name=ccewToggleWindow]').click()
    document.querySelector('button[name=ccewBack]').click()

    this.billingService.addInteraction({
      interactionType: 'WhatsApp',
      additionalInfo: {
        visitorId: this.widgetContainer.token,
      },
    })
    this.widgetContainer.triggerPublicEvent('widget_business_success', { state: widgetManager.getState(), confirmed: true })
  }

  initWhatsapp() {
    function autoResize() {
      if (this.scrollHeight > 100) {
        this.style.height = '100px'
        return
      }

      this.style.height = 'auto'
      this.style.height = this.scrollHeight + 'px'
    }

    const emojiContainer = this.$element.querySelector(`.${this.styleNamespace}__new-message__emoji--container`)
    const emojiButton = this.$element.querySelector('.cce-widget-whatsapp__new-message__emoji')
    let textarea = this.$element.querySelector('.cce-widget-whatsapp__new-message textarea')

    emojiButton.addEventListener('click', (_) => {
      if (emojiContainer.classList.contains('show')) {
        emojiContainer.style.display = 'none'
        emojiContainer.classList.remove('show')
      } else {
        emojiContainer.style.display = 'block'
        emojiContainer.classList.add('show')
      }
    })

    textarea.addEventListener('input', autoResize, false)

    textarea.addEventListener('keyup', (e) => {
      if (e.currentTarget.value != '') {
        e.currentTarget.parentElement.setAttribute('good', '')
      } else {
        e.currentTarget.parentElement.removeAttribute('good')
      }
    })

    const emojiPicker = this.$element.querySelector('emoji-picker')

    emojiPicker.addEventListener('emoji-click', (event) => {
      let emoji = event.detail.unicode
      textarea.value += emoji
      textarea.dispatchEvent(new Event('input'))
    })
    emojiPicker.addEventListener('blur', (event) => {
      emojiContainer.style.display = 'none'
    })

    textarea.addEventListener('click', (_) => {
      emojiContainer.style.display = 'none'
    })

    emojiPicker.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        emojiContainer.style.display = 'none'
      }
    })

    this.$element.querySelector('.cce-widget-whatsapp__new-message textarea').addEventListener('keydown', (e) => {
      if (e.defaultPrevented) return
      if (this.isMobile) return
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault()
        e.stopPropagation()
        this.sendMessage()
      }
    })
  }
}
